import { render, staticRenderFns } from "./webshop.vue?vue&type=template&id=11fe4f07&"
import script from "./webshop.vue?vue&type=script&lang=js&"
export * from "./webshop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports